import React, { Suspense } from "react";

const Component = React.lazy(() => import("./markmap"))

const Markmap = (props, svgRef) => {
  return (
    <Suspense fallback={null}>
      <Component {...props} ref={svgRef} />
    </Suspense>
  );
};

export default React.forwardRef(Markmap);
